import React from "react";
import SplitDetailCard from "../../../components/GmcDashbaord/SplitDetailCard";

export const renderSplitCards = (type, details, index) => {
  const splitDetails = [];
  const flex = localStorage.getItem("isFlex");
  if (details.number_of_employee >= 0)
    splitDetails.push({
      title:
        details.number_of_employee === 1 || details.number_of_employee === 0
          ? "Employee"
          : "Employees",
      number: details.number_of_employee || 0,
    });
  if (details.no_of_lives >= 0)
    splitDetails.push({
      title:
        details.no_of_lives === 1 || details.no_of_lives === 0
          ? "Life"
          : "Lives",
      number: details.no_of_lives || 0,
    });
  const topHeading =
    flex &&
    details.userplan_data &&
    (details.userplan_data.mandatory ? "Mandatory" : "Voluntary");
  
  let JSX = "";
  switch (type) {
    case "GMC_M":
    case "GMC":
      JSX = (
        <SplitDetailCard
          key={index.toString()}
          title="Group Mediclaim Cover"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "GPA":
      JSX = (
        <SplitDetailCard
          key={index.toString()}
          title="Group Personal Accident"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "GTL":
      JSX = (
        <SplitDetailCard
          key={index.toString()}
          title="Group Term Life"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "health_insurance":
      JSX = (
        <SplitDetailCard
          topHeading={topHeading === "Voluntary" && topHeading}
          title="Group Mediclaim Cover"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "personal_accident":
      JSX = (
        <SplitDetailCard
          topHeading={topHeading === "Voluntary" && topHeading}
          title="Group Personal Accident"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "term_life":
      JSX = (
        <SplitDetailCard
          topHeading={topHeading === "Voluntary" && topHeading}
          title="Group Term Life"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "mandatory_top_up_health":
      JSX = (
        <SplitDetailCard
          topHeading={topHeading === "Voluntary" && topHeading}
          title="Mandatory Top Up Health"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "top_up_health":
      JSX = (
        <SplitDetailCard
          topHeading={topHeading === "Voluntary" && topHeading}
          title="Top Up Health"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "opd_cover":
      JSX = (
        <SplitDetailCard
          topHeading={topHeading === "Voluntary" && topHeading}
          title="OPD Cover"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "critical_illness":
      JSX = (
        <SplitDetailCard
          topHeading={topHeading === "Voluntary" && topHeading}
          title="Critical Illness"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "health_checkup":
      JSX = (
        <SplitDetailCard
          topHeading={topHeading === "Voluntary" && topHeading}
          title="Health Checkup"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "parental_cover":
      JSX = (
        <SplitDetailCard
          topHeading={topHeading === "Voluntary" && topHeading}
          title="Parental Cover"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "health_insurance_parents":
      JSX = (
        <SplitDetailCard
          topHeading={topHeading === "Voluntary" && topHeading}
          title="Group Health Insurance (Parents)"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
    case "health_insurance_parents_in_laws":
      JSX = (
        <SplitDetailCard
          topHeading={topHeading === "Voluntary" && topHeading}
          title="Group Health Insurance (Parents-In-Laws)"
          details={splitDetails}
          last_updated={details && details.last_updated_at}
        />
      );
      break;
  }
  return JSX;
};
